import React from "react";
import { Film } from "react-feather";
import { Col, Row } from "reactstrap";

const Features = () => {
    const list = [
        {
            Icon: Film,
            title: "Anandvan",
            body: "For HIV/AIDS Affected Orphans in Infant India.While working in Infant Indian Kids, it was found that the women face many problems.",
        },
        {
            Icon: Film,
            title: "Aadhar Mahila Ashram",
            body: "A place for HIV Affected women.It was a rare opportunity for me to think over the woman who are at present staying in Infant India.",
        },
        {
            Icon: Film,
            title: "Navjeevan",
            body: "Under 'Navjeevan' project, they will have isolated shelter and for that Infant runners are going to appeal to the people for help and co-operation.",
        },
    ];

    return (
        <>
            {list.map((feature, index) => (
                <Col sm={4} className="my-4" key={index}>
                    <Row>
                        <Col xs={2} sm={3} md={2} lg={1}>
                            <feature.Icon size={35} className="mr-4" />
                        </Col>
                        <Col xs={10} sm={9} md={10} lg={11}>
                            <div
                                className="d-flex flex-column"
                                style={{ padding: "0 15px" }}
                            >
                                <h5>{feature.title}</h5>
                                <div>{feature.body}</div>
                            </div>
                        </Col>
                    </Row>
                </Col>
            ))}
        </>
    );
};

export default Features;
